import { render, staticRenderFns } from "./CompanyOvertimeMain.vue?vue&type=template&id=0295d9f3"
import script from "./CompanyOvertimeMain.vue?vue&type=script&lang=js"
export * from "./CompanyOvertimeMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports